import { Injectable } from '@angular/core';
import { environment } from "../../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { BehaviorSubject, Subject } from "rxjs";
import { Route, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { Stripe } from '@stripe/stripe-js';
import { loadStripe } from '@stripe/stripe-js';

@Injectable({
  providedIn: 'root'
})
export class ClubServicesService {

  url: any = environment.API_URL;
  stripePromise: Promise<Stripe>;
  stripeToken = 'pk_test_51Rfo41PLIPq0nHQwiNsG6dmzxeenbE8jfMHq44mtbzpIx6BDf4Z4skUZHlQbC7iotk5tSgGb2DnMeh7pXicbQo2T004oIuB8Gl';
  // stripeToken = 'pk_live_51Mwn3PF6k8u4g0kS8U3F1BZZIHblly6KtVP0t6REcMet7QsvPs6ZUs2MMuhZNbSAwz8YzAUlSv5OGu81VlQNUp4u00MBnKvE4H';
  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private route: Router,

  ) {
    this.stripePromise = loadStripe(this.stripeToken);
  }

  getStripeInstance(): Promise<Stripe> {
    return this.stripePromise;
  }


  getClubList(req_body: any) {
    return this.http.post(this.url + 'club/getEventsUpcoming', req_body);
  }

  getCancelledEventsList(req_body: any) {
    return this.http.post(this.url + 'club/getEventsCancelled', req_body);
  }

  getClubListById(id: any) {
    return this.http.get(this.url + 'club/getEvent/' + id);
  }


  getClubCanceledOrders() {
    return this.http.get(this.url + 'club/getCancelledOrders');
  }


  getClubListCompleted(req_body: any) {
    return this.http.post(this.url + 'club/getEventsCompleted', req_body);
  }

  addEvent(req_body: any) {
    return this.http.post(this.url + 'club/addEvent', req_body);
  }

  editEvent(req_body: any) {
    return this.http.put(this.url + 'club/editEvent', req_body);
  }

  getRestaurantNearBy() {
    return this.http.get(this.url + 'club/getRestaurants');

  }

  deleteTeam(teamId: string) {
    let req_body = {
      "eventId": teamId,
      "deleteOrder": false
    }
    return this.http.post(this.url + 'club/delEvent', req_body);
  }

  deleteEventOrders(teamId: string) {
    let req_body = {
      "eventId": teamId,
      "deleteOrder": true
    }
    return this.http.post(this.url + 'club/delEvent', req_body);
  }


  getTeamList(req_body: any) {
    return this.http.post(this.url + 'team/list', req_body);
  }


  generatePromoCodes(req_body: any) {
    return this.http.post(this.url + 'club/generate/promocode', req_body);
  }

  getPromoCodes() {
    return this.http.get(this.url + 'club/promocodes');
  }

  getClubOrderById(id: any) {
    return this.http.get(this.url + 'club/getOrder/' + id);
  }

  paymentRequestById(id: any) {
    return this.http.get(this.url + 'club/getPaymentRequestById/' + id);
  }

  getCards() {
    return this.http.get(this.url + 'stripe/get/cards');
  }

  payNow(data) {
    return this.http.post(this.url + 'club/pay/paymentNow', data)
  }

  getPaymentRequest() {
    return this.http.get(this.url + 'club/getPaymentRequests');
  }

  getClubNotification() {
    return this.http.get(this.url + 'club/getNotifications');
  }

  getPaidRequest() {
    return this.http.get(this.url + 'club/getPaymentRequestsPaid');
  }

  cancelOrder(id: any) {
    return this.http.put(this.url + 'club/cancel/order/' + id, {});
  }

  getRestaurantDetails(id) {
    return this.http.get(this.url + 'club/getRestaurant/' + id);
  }

  addCard(data) {
    return this.http.post(this.url + 'stripe/add/card', data)
  }

  stripeGenerateToken(data) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': `Bearer ${this.stripeToken}`
      })
    };
    return this.http.post('https://api.stripe.com/v1/tokens', data, httpOptions)
  }


  placeOrder(data: any) {
    return this.http.post(this.url + 'club/addOrder', data)
  }


  addFavourateResto(data: any) {
    return this.http.post(this.url + 'club/fav/restaurant', data)
  }

  removeFavourateResto(data: any) {
    return this.http.post(this.url + 'club/remove/fav/restaurant', data)
  }

  deleteTeamPlayer(data: any) {
    return this.http.post(this.url + 'team/delete/player', data);
  }

  searchTeamPlayer(data: any) {
    return this.http.post(this.url + 'team/search/player', data);
  }

  addTeamPlayer(data: any) {
    return this.http.post(this.url + 'team/add/player', data);
  }

  getUpcomingOrderByDate(data: any) {
    return this.http.post(this.url + 'club/getDateWiseUpcomingOrders', data);
  }

  saveNotes(data: any) {
    return this.http.put(this.url + 'club/updateCartNotes', data);
  }

}
